export type FaixaDisponibilidade = { inicio: string; fim: string };
export type DisponibilidadeDia = { dia: number; horarios: FaixaDisponibilidade[] };

export function disponibilidadeParaSalvar(restringir: boolean, dias: number[], horarios: FaixaDisponibilidade[], porDia?: DisponibilidadeDia[]) {
  // Omitir horariosPorDia preserva a agenda no backend para clientes antigos.
  // null sinaliza que este editor removeu a agenda diária intencionalmente.
  if (!restringir) return { dias: [], horarios: [], horariosPorDia: null };
  if (porDia !== undefined) return {
    dias: porDia.filter(day => day.horarios.length > 0).map(day => day.dia),
    horariosPorDia: porDia.map(day => ({ dia: day.dia, horarios: day.horarios.map(range => ({ ...range })) }))
  };
  return { dias: [...dias], horarios: horarios.map(range => ({ ...range })), horariosPorDia: null };
}

export function iniciarHorariosPorDia(dias: number[], horarios: FaixaDisponibilidade[]): DisponibilidadeDia[] {
  return Array.from({ length: 7 }, (_, dia) => ({ dia,
    horarios: dias.length && !dias.includes(dia) ? [] : (horarios.length ? horarios : [{ inicio: '00:00', fim: '23:59' }]).map(range => ({ ...range }))
  }));
}

export function horariosIncompletos(horarios: FaixaDisponibilidade[], porDia?: DisponibilidadeDia[]): boolean {
  const ranges = porDia === undefined ? horarios : porDia.flatMap(day => day.horarios);
  return ranges.some(range => !/^([01]\d|2[0-3]):[0-5]\d$/.test(range.inicio) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(range.fim));
}
